import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import JsonLdScript from '@/components/json-ld/JsonLdScript';
import { ServiceSchemaConfig } from '@/constants/service-schema';
import { buildServiceJsonLd, ServiceSeo } from '@/lib/service-schema';
interface Props {
  config: ServiceSchemaConfig;
  seo?: ServiceSeo | null;
}
const ServiceJsonLd: FC<Props> = t0 => {
  const $ = _c(5);
  const {
    config,
    seo
  } = t0;
  let t1;
  if ($[0] !== config || $[1] !== seo) {
    t1 = buildServiceJsonLd(config, seo);
    $[0] = config;
    $[1] = seo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <JsonLdScript data={t1} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default ServiceJsonLd;